import { Directive, HostListener, ElementRef } from '@angular/core';

@Directive({
  selector: '[appNumericInput]'
})
export class NumericInputDirective {
  private regex: RegExp = new RegExp(/^\d*\.?\d{0,2}$/);

  constructor(private el: ElementRef) {}

  @HostListener('keydown', ['$event'])
  onKeyDown(event: KeyboardEvent) {
    // Allow: backspace, tab, enter, escape, and arrow keys
    if (
      ['Backspace', 'Tab', 'Enter', 'Escape', 'ArrowLeft', 'ArrowRight'].includes(event.key)
    ) {
      return;
    }

    // Allow: Ctrl+A, Ctrl+C, Ctrl+V, Ctrl+X
    if (event.ctrlKey && ['a', 'c', 'v', 'x'].includes(event.key)) {
      return;
    }

    // Prevent invalid input
    const inputElement = this.el.nativeElement as HTMLInputElement;
    const selectionStart = inputElement.selectionStart || 0;
    const selectionEnd = inputElement.selectionEnd || 0;

    // Simulate the new value after the keypress
    const currentValue = inputElement.value;
    const newValue = parseFloat((currentValue.substring(0, selectionStart) +
    event.key +
    currentValue.substring(selectionEnd)).toString());

    if (!this.regex.test(newValue.toString())) {
      event.preventDefault();
    }
  }

  @HostListener('paste', ['$event'])
  onPaste(event: ClipboardEvent) {
    // Prevent pasting invalid text
    const clipboardData = event.clipboardData || (window as any).clipboardData;
    const pastedText = clipboardData.getData('text');

    if (!this.regex.test(pastedText)) {
      event.preventDefault();
    }
  }
}